import "./Layout.css";
import { Outlet } from "react-router-dom";
import Layout, { Content } from "antd/es/layout/layout";
import { Space } from "antd";
import Sider from "antd/es/layout/Sider";
import Sidebar from "../../../components/LayoutComponent/SideBar/Sidebar";
import TopBar from "../../../components/LayoutComponent/TopBar/topBar";

const UserPagesLayout = () => {
  return (
    <>
      {/* <Layout>
        <div className="bg-stone-100" style={{ minHeight: "100vh" }}>
          <Content>
            <Outlet />
          </Content>
        </div>
      </Layout> */}

      <Space
        direction="vertical"
        style={{ width: "100%", height: "100%" }}
        size={[0, 48]}
      >
        <Layout style={{ minHeight: "100vh" }}>
          {/* <Sider className="hidden md:block" width={300}>
            <div className="sideMenuFixed bg-blue-800">
              <Sidebar></Sidebar>
            </div>
          </Sider> */}
          <Layout>
            <Content className="content bg-white dark:bg-stone-900">
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </Space>
    </>
  );
};

export default UserPagesLayout;
